export type Assignee = {
  id: string
  name: string
}
export interface QueryData {
  id: string
  query_pseudo_id: string
  subject_pseudo_id: string
  site_pseudo_id: string
  timepoint_name: string
  category: QueryCategoryEnum
  status: QueryStatusEnum
  created_at: string
  assignees: Array<Assignee>
}

export enum QueryStatusEnum {
  OPEN = 'OPEN',
  REOPENED = 'REOPENED',
  GCIS_REVIEW = 'GCIS_REVIEW',
  QUERY_OVERDUE = 'QUERY_OVERDUE',
  RESOLVED = 'RESOLVED',
  UNRESOLVED = 'UNRESOLVED',
}

export enum QueryCategoryEnum {
  MISSING_IMAGE = 'Missing image',
  SLICE_THICKNESS = 'Slice thickness',
  MISSING_VISIT = 'Missing visit',
  E_FORM = 'E-form',
  REGULATORY_COMPLIANCE = 'regulatory_compliance',
}

export interface CreateQueryPayload {
  subject_id: string
  site_id: string
  timepoint: string
  category: QueryCategoryEnum
  description: string
  assignee_id?: string
}

export interface UpdateQueryPayload {
  id: string
  status?: QueryStatusEnum
  assignee_id?: string
  resolution_note?: string
}
export interface QueryUser {
  id: string
  name: string
}

export interface QueryContainer {
  id: string
  name: string
}

export interface QueryMessage {
  id: string
  content: string
  title?: string
  sender: {
    id: string
    name: string
    initials: string
    role?: string
  }
  timestamp: string
  isCurrentUser: boolean
}

export interface QueryUser {
  id: string
  name: string
}
export interface QueryDetails {
  id: string
  pseudo_id: string
  status: QueryStatusEnum
  subject_id: string
  query_template: {
    id: string
    category: QueryCategoryEnum
    title: string
    message: string
  }
  timepoint: {
    id: string
    name: string
    status: string
    containers: Array<{
      id: string
      name: string
    }>
  }
  site: {
    id: string
    pseudo_id: string
    name: string
  }
  assignees: Array<QueryUser>
  cc_users: Array<QueryUser>
  messages: QueryMessage[]
}
